import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartCComponent } from './cart-c/cart-c.component';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { ProductModule } from '../product/product.module';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [CartCComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule,
    ProductModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatSidenavModule
  ]
})
export class CartModule {}
